import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); await refresh(); return; }
        if (data.status === "expired" || tries > 20) { setStatus("error"); return; }
      } catch { if (tries > 20) { setStatus("error"); return; } }
      tries++; setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4 text-center">
      <Logo />
      <div className="mt-10 rounded-3xl border border-border bg-card p-10" data-testid="payment-result">
        {status === "checking" && <><Loader2 className="mx-auto h-12 w-12 animate-spin text-primary" /><h1 className="mt-4 font-display text-2xl font-bold">Confirming your payment…</h1><p className="mt-2 text-sm text-muted-foreground">This only takes a moment.</p></>}
        {status === "paid" && <><CheckCircle2 className="mx-auto h-12 w-12 text-bullish" /><h1 className="mt-4 font-display text-2xl font-bold">Subscription active!</h1><p className="mt-2 text-sm text-muted-foreground">Your plan has been upgraded. Enjoy the full KREONIS toolkit.</p><Link to="/app" className="mt-6 inline-block rounded-xl bg-primary px-6 py-2.5 text-sm font-semibold text-primary-foreground">Go to dashboard</Link></>}
        {status === "error" && <><XCircle className="mx-auto h-12 w-12 text-bearish" /><h1 className="mt-4 font-display text-2xl font-bold">Payment not confirmed</h1><p className="mt-2 text-sm text-muted-foreground">We couldn't confirm your payment. If you were charged, it will reflect shortly.</p><Link to="/pricing" className="mt-6 inline-block rounded-xl border border-border px-6 py-2.5 text-sm font-semibold">Back to pricing</Link></>}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4 text-center">
      <Logo />
      <div className="mt-10 rounded-3xl border border-border bg-card p-10">
        <XCircle className="mx-auto h-12 w-12 text-muted-foreground" />
        <h1 className="mt-4 font-display text-2xl font-bold">Checkout cancelled</h1>
        <p className="mt-2 text-sm text-muted-foreground">No charge was made. You can pick a plan whenever you're ready.</p>
        <Link to="/pricing" className="mt-6 inline-block rounded-xl bg-primary px-6 py-2.5 text-sm font-semibold text-primary-foreground">Back to pricing</Link>
      </div>
    </div>
  );
}
